import React, { ReactNode } from 'react';
import cx from 'classnames';

import Button, {
  Props as ButtonProps,
} from '../../components/atoms/button/Button';
import PrimaryButton from '../../components/primaryButton/PrimaryButton';

import styles from './Layout.module.css';

type LayoutButtonProps = Omit<ButtonProps, 'children'> & {
  label?: string;
};

export type Props = {
  banner?: {
    src: string;
    alt: string;
  };
  prompt: ReactNode;
  nextButton?: LayoutButtonProps;
  secondaryButton?: LayoutButtonProps;
  skipButton?: LayoutButtonProps;
  backButton?: LayoutButtonProps;
  showSkip?: boolean;
  showNext?: boolean;
  showBack?: boolean;
  showHeader?: boolean;
  explanation?: string | ReactNode;
  children?: ReactNode;
  className?: string;
};

export default ({
  banner: { src, alt } = { src: '', alt: '' },
  prompt,
  nextButton,
  secondaryButton,
  skipButton,
  backButton,
  showNext = true,
  showSkip = true,
  showBack = true,
  explanation,
  children,
  className,
}: Props) => (
  <div data-testid="layout" className={cx(styles.layout, className)}>
    <div className={styles.banner}>
      {src && <img src={src} alt={alt} className={styles.bannerImage} />}
      <h1 className={styles.prompt}>{prompt}</h1>
    </div>

    <div className={styles.content}>
      {explanation && (
        <span data-testid="layout-explanation" className={styles.explanation}>
          {explanation}
        </span>
      )}

      {children}

      <div className={styles.buttons}>
        <div className={styles.backButtonContainer}>
          {backButton && showBack && (
            <Button {...backButton} className={styles.backButton} unstyled>
              {backButton.label ? backButton.label : 'Back'}
            </Button>
          )}
        </div>

        <div className={styles.centerButtonsContainer}>
          {secondaryButton && secondaryButton.label && (
            <Button
              {...secondaryButton}
              className={styles.secondaryButton}
              unstyled
            >
              {secondaryButton.label}
            </Button>
          )}

          {showNext && nextButton && (
            <PrimaryButton {...nextButton}>
              {nextButton.label ? nextButton.label : 'Next'}
            </PrimaryButton>
          )}
        </div>

        <div className={styles.skipButtonContainer}>
          {skipButton && showSkip && (
            <Button {...skipButton} className={styles.skipButton} unstyled>
              {skipButton.label ? skipButton.label : 'Skip'}
            </Button>
          )}
        </div>
      </div>
    </div>
  </div>
);
